
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from "react";
import { faAddressBook, faIdCard, faPhone, faFile, faBuilding, faBirthdayCake } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Form, Card, Button, Badge, Container, InputGroup } from '@themesberg/react-bootstrap';

import api from "../../api/axios";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useHistory } from "react-router-dom";
import { dashboardUser, updateProfile, updateProfileImage, updateProfileFile, dashboardUserFiles } from "../../api/services";
import Preloader from "../../components/Preloader"; // Path to your code above

export default () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [altphoneNumber, setAltPhoneNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [dob, setDob] = useState();
  const [gstNumber, setGstNumber] = useState("");
  const [profilePic, setProfilePic] = useState(null);
  const [panNumber, setPanNumber] = useState("");
  const [profilePicPreview, setProfilePicPreview] = useState(null);
  const [gstFile, setGstFile] = useState(null);
  const [panFile, setPanFile] = useState(null);
  const [gstFilePreview, setGstFilePreview] = useState(null);
  const [panFilePreview, setPanFilePreview] = useState(null);
  // const [preview, setPreview] = useState(null);
  const [address, setAddress] = useState("");
  const [isActive, setIsActive] = useState(Boolean);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);
      try {
        const result = await dashboardUser();
        console.log("Dashboard Data:", result);
        setIsActive(result.isActive);
        setFullName(result.fullName);
        setEmail(result.email);
        setRole(result.role);
        setPhoneNumber(result.phone);
        setPanNumber(result.panNumber);
        setCompanyName(result.companyName);
        setGstNumber(result.gstNumber);
        setAddress(result.address);
        setPanNumber(result.panNumber);
        setProfilePicPreview(result.profileImg);
        setAltPhoneNumber(result.altPhone);
        // setPreview(result.profileImg);
        setDob(result.dob);
        if (result.profileImg != null) {
          console.log("Preview is available!");
          setSuccess("You Have Already Submited");
        }
        console.log("User Active Status:", result.isActive);
        console.log("User Role:", result.role);

        const gstfile = await dashboardUserFiles(null, 101);
        console.log("GST FILE RAW:", gstfile);

        if (gstfile && gstfile.size > 0) {
          const fileURL = URL.createObjectURL(gstfile);
          console.log("Generated GST URL:", fileURL);
          setGstFilePreview(fileURL);
        } else {
          console.log("GST file is empty or null");
        }
          const panfile = await dashboardUserFiles(null, 102);
          console.log("PAN FILE RAW:", panfile);

          if (panfile && panfile.size > 0) {
            const fileURL = URL.createObjectURL(panfile);
            console.log("Generated PAN URL:", fileURL);
            setPanFilePreview(fileURL);
          } else {
            console.log("PAN file is empty or null");
          }
        // const fileURL = URL.createObjectURL(gstfile);
        // setGstFilePreview(fileURL);
        // console.log("gstFilePreview:", gstFilePreview);
      } catch (error) {
        console.log("Dashboard Data fetch Error:", error.response?.data || error.message);
      }
      finally {
        setShowLoader(false);
      }
    };
    fetchData();
  }, []);



  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowLoader(true);
    setSuccess("");
    setError("");

    try {
      const payload = {
        phone: phoneNumber,
        altPhone: altphoneNumber,
        role: "ADMIN",
        companyName,
        gstNumber,
        panNumber,
        address,
        dob,
      };

      console.log("Form submitted with data:", payload);

      const resp = await updateProfile(payload);

      console.log("Profile update response:", resp);

      const formData = new FormData();
      if (profilePic) {
        console.log("Profile picture selected:", profilePic);
        formData.append("profileImg", profilePic);
        formData.append("actionName", "100");
        const resp1 = await updateProfileImage(formData)
        console.log("RespL:", resp1);
      }

      const formData2 = new FormData();
      if (gstFile) {
      formData2.append("gstDocPdf", gstFile);
      formData2.append("actionName", "101");
      const resp2 = await updateProfileFile(formData2);
      console.log("Resp2:", resp2);
      }

      const formData3 = new FormData();
      if (panFile) {
      formData3.append("panDocPdf", panFile);
      formData3.append("actionName", "102");
      const resp3 = await updateProfileFile(formData3);
      console.log("Resp3:", resp3);
      }

      setSuccess(resp?.message || "Profile updated successfully!");
    } catch (error) {
      console.log("Form submission error:", error.response?.data || error.message);

      // ✅ Better error handling
      setError(
        // error.response?.data?.message ||
        // error.response?.data?.error ||
        "Something went wrong!"
      );
    } finally {
      setShowLoader(false);
    }
  };

  const getMaxDOB = () => {
    const today = new Date();
    today.setFullYear(today.getFullYear());
    return today.toISOString().split("T")[0];
  };


  return (
    <main>
      {/* <Preloader show={showLoader} /> */}
      {isActive ? (
        <Card className="shadow-sm border-0 mt-4 vh-120">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Profile Details</h5>

              <Badge bg={isActive ? "success" : "warning"}>
                {isActive ? "Active" : "Pending"}
              </Badge>
            </div>


          <Row className="g-4">

            {/* Profile Image */}
            <Col md={12} className="text-center">
              {profilePicPreview ? (
                <img
                  src={profilePicPreview}
                  alt="Profile"
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "2px solid #ddd"
                  }}
                />
              ) : (
                <div
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    background: "#f0f0f0",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  No Image
                </div>
              )}
            </Col>

            <Col md={12}>
              <div className="border rounded">

                {/* Row */}
                {[
                  ["Name", fullName],
                  ["Email", email],
                  ["Role", role],
                  ["Phone", phoneNumber],
                  ["Alternate Phone", altphoneNumber],
                  ["Date of Birth", dob],
                  ["Company", companyName],
                  ["GST Number", gstNumber],
                  ["PAN Number", panNumber],
                  ["Address", address],
                ].map((item, index) => (
                  <Row key={index} className="py-2 border-bottom m-0">

                    {/* Left Column (Label) */}
                    <Col
                      md={6}
                      style={{
                        borderRight: "1px solid #ddd", // 🔥 vertical divider
                        fontWeight: "600",
                        background: "#fafafa"
                      }}
                    >
                      {item[0]}
                    </Col>

                    {/* Right Column (Value) */}
                    <Col md={6}>
                      {item[1] || "-"}
                    </Col>

                  </Row>
                ))}

                {/* GST FILE */}
                <Row className="py-2 border-bottom m-0">
                  <Col md={6} style={{ borderRight: "1px solid #ddd", fontWeight: "600", background: "#fafafa" }}>
                    GST Document
                  </Col>
                  <Col md={6}>
                    {gstFilePreview ? (
                      <a href={gstFilePreview} target="_blank" rel="noopener noreferrer">
                        📄 View GST PDF
                      </a>
                    ) : "-"}
                  </Col>
                </Row>

                {/* PAN FILE */}
                <Row className="py-2 m-0">
                  <Col md={6} style={{ borderRight: "1px solid #ddd", fontWeight: "600", background: "#fafafa" }}>
                    PAN Document
                  </Col>
                  <Col md={6}>
                    {panFilePreview ? (
                      <a href={panFilePreview} target="_blank" rel="noopener noreferrer">
                        📄 View PAN PDF
                      </a>
                    ) : "-"}
                  </Col>
                </Row>

              </div>
            </Col>

          </Row>
          </Card.Body>
        </Card>
      )
        :
        (
          <Container className="px-0" style={{ backgroundColor: `#ffffff` }}>
            <section className="d-flex align-items-center my-5 mt-lg-2 mb-lg-5" >
              <Container>
                <div className="d-flex justify-content-center align-items-center mt-4">
                </div>
                {error && (<div class="alert alert-danger">
                  {error}
                </div>)}

                {
                  success && (<div class="alert alert-success">
                    {success}
                  </div>)
                }
                <Row className="justify-content-center form-bg-image">
                  <Col lg={12} /*className="d-flex align-items-center justify-content-center"*/>
                    <Form className="mt-4" onSubmit={handleSubmit}>

                      <Form.Group id="profilePic" className="mb-4 text-center">
                        <Form.Label>Profile Picture</Form.Label>

                        <div className="mb-3">
                          {profilePicPreview ? (
                            <img
                              src={profilePicPreview}
                              alt="Preview"
                              style={{
                                width: "100px",
                                height: "100px",
                                borderRadius: "50%",
                                objectFit: "cover",
                                border: "2px solid #ddd"
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                width: "100px",
                                height: "100px",
                                borderRadius: "50%",
                                background: "#f0f0f0",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}
                            >
                              No Image
                            </div>
                          )}
                        </div>

                        {/* Hidden Input */}
                        <Form.Control
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              setProfilePic(file);
                              setProfilePicPreview(URL.createObjectURL(file));
                            }
                          }}
                        />
                      </Form.Group>

                      

                      <Form.Group id="dob" className="mb-2">
                        <Form.Label>Date of Birth</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>📅</InputGroup.Text>
                          <Form.Control
                            required
                            type="date"
                            value={dob}
                            onChange={(e) => setDob(e.target.value)}
                            // max={new Date().toISOString().split("T")[0]} // prevents future dates
                            max={getMaxDOB()}
                          />
                        </InputGroup>
                      </Form.Group>

                      <Form.Group id="phone" className="mb-2">
                        <Form.Label>Phone Number (Should Be Same As whatsApp)</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faPhone} />
                          </InputGroup.Text>
                          <Form.Control
                            autoFocus
                            required
                            type="tel"
                            placeholder="Phone Number"
                            value={phoneNumber}
                            maxLength={10}
                            minLength={10}
                            onChange={(e) => {
                              const value = e.target.value;

                              // Allow only digits (0-9)
                              if (/^\d*$/.test(value)) {
                                setPhoneNumber(value);
                              }
                            }}
                            isInvalid={phoneNumber && phoneNumber.length !== 10}
                          />
                        </InputGroup>
                      </Form.Group>

                      <Form.Group id="alt-phone" className="mb-2">
                        <Form.Label>Alternate Phone Number (Optional)</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faPhone} />
                          </InputGroup.Text>
                          <Form.Control
                            autoFocus
                            type="tel"
                            placeholder="Phone Number"
                            value={altphoneNumber}
                            maxLength={10}
                            minLength={10}
                            onChange={(e) => {
                              const value = e.target.value;

                              // Allow only digits (0-9)
                              if (/^\d*$/.test(value)) {
                                setAltPhoneNumber(value);
                              }
                            }}
                            isInvalid={altphoneNumber && altphoneNumber.length !== 10}
                          />
                        </InputGroup>
                      </Form.Group>

                      <Form.Group id="company" className="mb-2">
                        <Form.Label>Company Name</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faFile} />
                          </InputGroup.Text>
                          <Form.Control
                            autoFocus
                            required
                            type="text"
                            placeholder="Company Name"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group>

                      <Form.Group id="gst-document" className="mb-4 text-center">
                        <Form.Label>GST Document</Form.Label>

                        <div className="mb-3">
                          {gstFilePreview ? (
                              // 👉 PDF Preview (icon + click to open)
                              <div
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  borderRadius: "10px",
                                  background: "#f0f0f0",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  border: "2px solid #ddd"
                                }}
                              >
                                
                                <a
                                  href={gstFilePreview}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ textDecoration: "none" }}
                                >
                                  📄 View PDF
                                </a>
                              </div>
                            
                          ) : (
                            <div
                              style={{
                                width: "100px",
                                height: "100px",
                                borderRadius: "10px",
                                background: "#f0f0f0",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}
                            >
                              No File
                            </div>
                          )}
                        </div>

                        {/* File Input */}
                        <Form.Control
                          type="file"
                          accept=".pdf,image/*"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              if (file.type !== "application/pdf") {
                                alert("Only PDF files are allowed");
                                e.target.value = null; // reset input
                                return;
                              }
                              setGstFile(file);

                              const fileURL = URL.createObjectURL(file);
                              setGstFilePreview(fileURL);

                            }
                          }}
                        />
                      </Form.Group>

                      <Form.Group id="gst_number" className="mb-2">
                        <Form.Label>GST Number</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faIdCard} />
                          </InputGroup.Text>
                          <Form.Control
                            autoFocus
                            required
                            type="text"
                            placeholder="GST Number"
                            value={gstNumber}
                            maxLength={15}
                            minLength={15}
                            onChange={(e) => setGstNumber(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group>
                      
                      <Form.Group id="pan_document" className="mb-4 text-center">
                        <Form.Label>PAN Document</Form.Label>

                        <div className="mb-3">
                          {panFilePreview ? (
                              // 👉 PDF Preview (icon + click to open)
                              <div
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  borderRadius: "10px",
                                  background: "#f0f0f0",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  border: "2px solid #ddd"
                                }}
                              >
                                
                                <a
                                  href={panFilePreview}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ textDecoration: "none" }}
                                >
                                  📄 View PDF
                                </a>
                              </div>
                            
                          ) : (
                            <div
                              style={{
                                width: "100px",
                                height: "100px",
                                borderRadius: "10px",
                                background: "#f0f0f0",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}
                            >
                              No File
                            </div>
                          )}
                        </div>

                        {/* File Input */}
                        <Form.Control
                          type="file"
                          accept=".pdf,image/*"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              if (file.type !== "application/pdf") {
                                alert("Only PDF files are allowed");
                                e.target.value = null; // reset input
                                return;
                              }
                              setPanFile(file);

                              const fileURL = URL.createObjectURL(file);
                              setPanFilePreview(fileURL);

                            }
                          }}
                        />
                      </Form.Group>
                      
                      <Form.Group id="pan_number" className="mb-2">
                        <Form.Label>PAN Number</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faIdCard} />
                          </InputGroup.Text>
                          <Form.Control
                            autoFocus
                            required
                            type="text"
                            placeholder="PAN Number"
                            value={panNumber}
                            maxLength={10}
                            minLength={10}
                            onChange={(e) => setPanNumber(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group>

                      {/* <Form.Group id="dl_number" className="mb-4">
                        <Form.Label>DL Number</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faIdCard} />
                          </InputGroup.Text>
                          <Form.Control
                            autoFocus
                            required
                            type="text"
                            placeholder="DL Number"
                            value={dlNumber}
                            onChange={(e) => setDlNumber(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group> */}

                      <Form.Group id="address" className="mb-2">
                        <Form.Label>Address</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faAddressBook} />
                          </InputGroup.Text>
                          <Form.Control
                            autoFocus
                            required
                            type="text"
                            placeholder="Address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group>

                      <Button variant="primary" type="submit" className="w-100">
                        Submit for Approval
                      </Button>
                    </Form>
                    <div className="d-flex justify-content-center align-items-center mt-4">
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
          </Container>
        )
      }
    </main>
  );
};
